import React, {useState} from 'react'
import Modal from 'react-bootstrap/Modal'
import {Button, Col, Container, Form, Row} from 'react-bootstrap'
import api from '../../utils/Api'
import Select from 'react-select'
import {BANK_LIST_OPTIONS} from '../../constants/Common'
import {reactSelectValue} from '../../utils/Helper'

export interface IDialog {
  show: boolean
  onClose(): void
  onSubmitSuccess(res: any): void
}

const ModalPaymentMethodForm: React.FC<IDialog> = (props) => {
  const [form, setForm] = useState<any>({})

  return (
    <Modal show={props.show} onHide={() => props.onClose()}>
      <Modal.Header closeButton className={'py-2'}>
        <Modal.Title>เพิ่มข้อมูลบัญชี</Modal.Title>
      </Modal.Header>
      <Modal.Body className={'p-2'}>
        <Form
          onSubmit={(e) => {
            e.preventDefault()

            api.request('account/payment-method', (r,s)=>{
              if (!r) return

              setForm({})
              props.onSubmitSuccess(r)
            }, api.form(form, null), 'POST', {showSuccess: true})
          }}
        >
          <Container>
            <Row>
              <Col xs={12}>
                <Form.Group className='mb-5' controlId={'bank'}>
                  <Form.Label>ธนาคาร</Form.Label>
                  <Select
                    classNamePrefix='react-select'
                    options={BANK_LIST_OPTIONS}
                    name={`bank`}
                    onChange={(opt) => {
                      setForm({
                        ...form,
                        bank: opt.value,
                      })
                    }}
                    value={reactSelectValue(
                      BANK_LIST_OPTIONS,
                      form.bank
                    )}
                  />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className='mb-5' controlId={'accountNo'}>
                  <Form.Label>เลขที่บัญชี</Form.Label>
                  <Form.Control
                    name={`accountNo`}
                    value={form.accountNo}
                    onChange={(e) => {
                      setForm({
                        ...form,
                        accountNo: e.target.value,
                      })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xs={12}>
                <Form.Group className='mb-5' controlId={'accountName'}>
                  <Form.Label>ชื่อบัญชี</Form.Label>
                  <Form.Control
                    name={`accountName`}
                    value={form.accountName}
                    onChange={(e) => {
                      setForm({
                        ...form,
                        accountName: e.target.value
                      })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button type={'submit'} variant={'primary'}>{'สร้าง'}</Button>
          </Container>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default ModalPaymentMethodForm
